import {Component, EventEmitter, Input, Output} from "@angular/core";
import {AnalyticsService} from "../../orchestration/analytics.service";
import {NavigationService} from "../../orchestration/navigation.service";

@Component({
    selector: "woa-legal-panel",
    templateUrl: "./legal-panel.component.html"
})
export class LegalPanelComponent {
    @Input() messageSet: string;
    @Input() messageParams: any = {};
    @Input() showFeedback: boolean = false;

    @Output() onLinkOpened: EventEmitter<string> = new EventEmitter();

    constructor(private analyticsService: AnalyticsService,
                private navigationService: NavigationService) {
    }

    async feedback(): Promise<void> {
        this.onLinkOpened.emit("feedback");
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption("feedback");
        return this.navigationService.createPage("woa-feedback-page");
    }

    async showAdminDetails(display: "terms" | "privacy"): Promise<void> {
        this.onLinkOpened.emit(display);
        // noinspection ES6MissingAwait
        this.analyticsService.trackNavOption(display);
        return this.navigationService.createPage("woa-legal-page", {display: display});
    }
}



// WEBPACK FOOTER //
// ./src/app/legal/legal-panel/legal-panel.component.ts